<div class="form-group mt-2" *ngIf="file">
  <ng-container *ngIf="label">
    <app-label-info>{{ label }}</app-label-info>
  </ng-container>

  <div class="d-flex justify-content-start">
    <img class="document-logo--height" src="{{ icon }}" />

    <div class="pl-1">
      <label class="d-block mb-0">{{ file.name }}</label>
      <label class="d-block mb-0" *ngIf="file.size">{{ fileSize }} (MB)</label>
    </div>

    <div class="w-100">
      <span (click)="onClickDownload()" class="btn btn-secondary float-right">DOWNLOAD</span>
    </div>
  </div>
</div>
